import { differenceInYears, parse } from "date-fns";

import { DateFormat } from "@/constants/DateFormat";

const MinimumAge = {
  Adult: 18,
  Teen: 10,
};

const getAge = (dateOfBirth: Date): number => {
  return differenceInYears(new Date(), dateOfBirth);
};

const isAdult = (dateOfBirth: Date): boolean => {
  return getAge(dateOfBirth) >= MinimumAge.Adult;
};

const isTeen = (dateOfBirth: Date): boolean => {
  const age = getAge(dateOfBirth);
  return age >= MinimumAge.Teen && age < MinimumAge.Adult;
};

const isPediatric = (dateOfBirth: Date): boolean => {
  return getAge(dateOfBirth) < MinimumAge.Teen;
};

const parseProfileDateOfBirth = (dateOfBirth: string): Date => {
  return parse(dateOfBirth, DateFormat.yearMonthDay, new Date());
};

export { getAge, isAdult, isPediatric, isTeen, parseProfileDateOfBirth };
